/**
 * Identifies the Google Cloud Storage bucket that holds Walter Living
 * property photos. Used to scope the URL rewrite so non-Walter URLs are
 * left untouched.
 */
const WALTER_PHOTO_BUCKET = "walter-companies-property-photos";

/**
 * Defensively normalizes a Walter Living property photo URL so it points at a
 * surviving image variant.
 *
 * Walter stopped storing the `/original/` variants (and deletes them for older
 * properties), but many of our cached URLs still reference `/original/`. The
 * derived `tiny` / `medium` / `large` variants are kept indefinitely, so we
 * rewrite `/original/` → `/medium/` (the variant Walter's API now returns).
 *
 * Only Walter photo URLs are touched; every other URL is returned unchanged.
 */
export const getWalterImageUrl = ({
  url,
}: {
  /**
   * The (possibly stale) photo URL as received from the Walter Living API or
   * our cache
   */
  url: string;
}): string =>
  url.includes(WALTER_PHOTO_BUCKET)
    ? url.replace("/original/", "/medium/")
    : url;

/**
 * Maps {@link getWalterImageUrl} over a list of photo URLs.
 */
export const getWalterImageUrls = ({
  urls,
}: {
  /**
   * The list of (possibly stale) photo URLs to normalize
   */
  urls: string[];
}): string[] => urls.map((url) => getWalterImageUrl({ url }));
